export enum EventStatus {
    DRAFT = 'draft',
    PUBLISHED = 'published',
}
